import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getLiquidityPool } from "../../utils/contractHelpers";
import { LUCKIFY_CONTRACT_ADDRESS } from "../../utils/Enviroment";


export const AddLiquidity = () => {
    const web3 = useWeb3();
    const stakingAddress = LUCKIFY_CONTRACT_ADDRESS;
    const contract = getLiquidityPool(stakingAddress, web3);
    const { account } = useWeb3React()
    const AddLiquidityHook = useCallback(
        async (amount) => {
            const Amount = web3.utils.toWei(amount?.toString(), 'ether');
            let gasPrice = await web3.eth.getGasPrice();
            // gasPrice = parseInt(gasPrice) + 1000000000;
            try {
                const gas = await contract?.methods?.deposit(Amount)?.estimateGas({ from: account })
                const deposit = await contract?.methods?.deposit(Amount)?.send({ from: account, gas: gas, gasPrice: gasPrice })
                return deposit;
            } catch (e) {
                throw e;
            }
        },
        [contract, web3, account]
    );
    return { AddLiquidityHook: AddLiquidityHook };
};

export default AddLiquidity;










